export default function({ state, commit, dispatch }, patient) {
    commit('startCreatingPatient')

    return dispatch('post', {
        url: '/provider/' + state.id + '/patient',
        data: patient
    }, {
        root: true
    })
    .then((patient) => {
        commit('finishCreatingPatient')
        commit('addPatient', patient)
		return patient
    })
    .catch((error) => {
        commit('finishCreatingPatient')
		console.log(error)
		throw error
    })
}
